import { types } from "mobx-state-tree";
import StatusCode from "./StatusCode";

export const StatusCodeStore = types
  .model('StatusCodeStore', {
    statusCodes: types.optional(types.array(StatusCode), []),
  })
  .actions((self) => ({
    setStatusCodes(statusCodes) {
      let newStatusCodes = [];
      for (let i = 0; i < statusCodes.length; i++) {
        newStatusCodes.push(StatusCode.create(statusCodes[i]));
      }
      self.statusCodes = [...newStatusCodes];
    },
  }));

export default StatusCodeStore;
